var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }